const bodyScrollLock = require('body-scroll-lock');

function openBookCardPopup() {
    let element = document.querySelector('.book-new__scroll-selector');

    bodyScrollLock.disableBodyScroll(element, {reserveScrollBarGap: true});

    $('.book-new__popup-overlay, .book-new__popup-swiper').addClass('open');

    $('body').addClass('modal-open');
}

function closeBookCardPopup () {
    $('.book-new__popup-overlay, .book-new__popup-swiper').removeClass('open');

    bodyScrollLock.clearAllBodyScrollLocks();

    $('body').removeClass('modal-open');
}

$(document).on('click', '.book-new__popup-close, .popup-decline', function () {
    closeBookCardPopup();
});

$(document).on('click', '.book-new__popup-overlay, .book-new__popup-swiper', function (event) {
    if ($(event.target).closest('.book-new__delete-popup-wrapper, .book-new__shelf-popup-wrapper, .book-new__popup-swiper-wrapper').length) return;

    if (!$(this).hasClass('open')) return;

    closeBookCardPopup();
});

$(document).on('click', '.book-new__get-popup', function () {
    let that = $(this),
        wrapper = $('body'),
        id = that.data('id'),
        url = that.data('url');

    $.ajax({
        'type': 'POST',
        'url': url,
        'data': {id: id},
        'beforeSend': function () {
            $('.book-new__popup').remove();
        },
        'success': function (result) {
            wrapper.append(result);

            openBookCardPopup();
        },
        'error': function () {
            console.error('BookCard popup ajax error')
        },
    });
})

$(document).on('click', '.book-new__delete', function () {
    let that = $(this),
        id = that.data('id'),
        url = that.data('url');

    $.ajax({
        'type': 'POST',
        'url': url,
        'data': {id: id},
        'success': function () {
            closeBookCardPopup();

            location.reload();
        },
        'error': function () {
            console.error('BookNew delete ajax error')
        },
    });
})

$(document).on('click', '.book-new__detail-button', function () {
    let that = $(this),
        container = that.parents('.book-new__detail'),
        menu = container.find('.book-new__detail-menu'),
        menuDom = menu.get(0);

    menu.removeClass('position-top');

    $('.book-new__detail-button').not(that).parents('.book-new__detail').removeClass('open');

    container.toggleClass('open')

    if (window.innerHeight - menuDom.getBoundingClientRect().bottom < 10) {
        menu.addClass('position-top')
    }

    $(document).on('click', function (event) {
        if ($(event.target).closest('.book-new__detail-button, .book-new__detail-menu').length) return;

        $('.book-new__detail').removeClass('open');
    });
});

$(document).on('click', '.book-new__popup-shelf', function () {
    let that = $(this),
        button = $('.book-new__shelf');

    if (!$('.book-new__popup-shelf[data-initial]').length) {
        $('.book-new__popup-shelf.active').attr('data-initial', true)
    }

    $('.book-new__popup-shelf').removeClass('active');

    that.addClass('active');

    if (that.attr('data-initial') !== undefined) {
        button.attr('disabled', true);

        button.removeAttr('data-destination');
    } else {
        button.attr('data-destination', that.data('type'));

        button.removeAttr('disabled');
    }
})

$(document).on('click', '.book-new__shelf', function () {
    let that = $(this),
        id = that.data('id'),
        url = that.data('url'),
        destination = that.data('destination');

    $.ajax({
        'type': 'POST',
        'url': url,
        'data': {destination: destination, id: id},
        'success': function () {
            closeBookCardPopup();

            location.reload();
        },
        'error': function () {
            console.error('BookNew shelf ajax error')
        },
    });
})